import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import BrandImageListItem from './BrandImageListItem'

const BrandImages = (props) => {
  const { brandPayload } = props
  const {
    brand,
    callbacks: { uploadBrandImage },
    loading,
  } = brandPayload

  const {
    colour_primary,
    id,
    logo,
    mono_logo,
  } = brand

  const {
    small: logoUrl,
    file_name: logoFileName,
  } = logo || {}

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: id,
      attachable_type: 'Brand',
      attachment_type: 'marketing_cover_image',
    },
    performHttpRequests: !!brand,
  })
  const { filteredAttachments } = attachmentsPayload
  const marketingCoverImage = filteredAttachments[0]
    || { attachable_id: id, attachable_type: 'Brand', attachment_type: 'marketing_cover_image' }

  const marketingCoverImageUrl = digObject(marketingCoverImage, 'links.original_url')
  const { file_file_name } = marketingCoverImage

  const {
    callbacks: {
      createOrEditAttachment,
    },
  } = useAttachment(marketingCoverImage)

  const {
    small: monoLogoUrl,
    file_name: monoLogoFileName,
  } = mono_logo || {}

  return (
    <DashboardModule loading={loading} title="Images">
      {!loading && (
        <Box flexDirection="column">
          <BrandImageListItem
            backgroundColour={colour_primary}
            callbacks={{
              launchModalFn: () => uploadBrandImage({ type: 'logo' }),
            }}
            fileName={logoFileName}
            imageUrl={logoUrl}
            title="Brand Logo"
          />

          <BrandImageListItem
            callbacks={{
              launchModalFn: () => uploadBrandImage({ type: 'mono_logo' }),
            }}
            fileName={monoLogoFileName}
            imageUrl={monoLogoUrl}
            title="Mono Logo"
          />

          <BrandImageListItem
            callbacks={{
              launchModalFn: createOrEditAttachment,
            }}
            fileName={file_file_name}
            imageBackgroundSize="cover"
            imageUrl={marketingCoverImageUrl}
            title="Marketing Cover"
          />
        </Box>
      )}
    </DashboardModule>
  )
}

BrandImages.propTypes = {
  brandPayload: PropTypes.shape({
    brand: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    loading: PropTypes.bool,
  }).isRequired,
}

export default BrandImages
